import { render, staticRenderFns } from "./gyss.vue?vue&type=template&id=529b21fe&scoped=true"
import script from "./gyss.vue?vue&type=script&lang=js"
export * from "./gyss.vue?vue&type=script&lang=js"
import style0 from "./gyss.vue?vue&type=style&index=0&id=529b21fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b21fe",
  null
  
)

export default component.exports